// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__B1dr+","box":"CardDetails_box__6kKai","icon":"CardDetails_icon__BXtpX","icon_text_container":"CardDetails_icon_text_container__fnUuM"};